import { persistLocalePreference } from 'helpers/localePreference';
import {
  SupportedLocale,
  useUpdateMyLocalePreferenceMutation,
} from 'generated/graphql';

/**
 * Wraps the updateMyLocalePreference mutation so that a locale selector can
 * persist the user's explicitly-selected locale (CR-219). After the mutation
 * succeeds the preference is stored so the Apollo link applies an
 * Accept-Language override on subsequent requests.
 */
export const useUpdateMyLocalePreference = () => {
  const [mutate, state] = useUpdateMyLocalePreferenceMutation();

  const updateMyLocalePreference = async (locale: SupportedLocale) => {
    const result = await mutate({ variables: { locale } });
    const preference = result.data?.updateMyLocalePreference.preferredLocale;
    if (preference) {
      persistLocalePreference(preference.source, preference.locale);
    }
    return result;
  };

  return { updateMyLocalePreference, ...state };
};
